module.exports = __webpack_public_path__ + "static/media/ease.79defe27.svg";